// import consts from '../../server/consts'
// export default consts
export default {
  dateFormat: 'DD/MM/YYYY',
  defaultVatPercent: 9,
  subscriptionPrice: 150,

  months: {
    1: 'Януари',
    2: 'Февруари',
    3: 'Март',
    4: 'Април',
    5: 'Май',
    6: 'Юни',
    7: 'Юли',
    8: 'Август',
    9: 'Септември',
    10: 'Октомври',
    11: 'Ноември',
    12: 'Декември'
  },

  monthsOptions: [
    {id: 1, title: 'Януари'},
    {id: 2, title: 'Февруари'},
    {id: 3, title: 'Март'},
    {id: 4, title: 'Април'},
    {id: 5, title: 'Май'},
    {id: 6, title: 'Юни'},
    {id: 7, title: 'Юли'},
    {id: 8, title: 'Август'},
    {id: 9, title: 'Септември'},
    {id: 10, title: 'Октомври'},
    {id: 11, title: 'Ноември'},
    {id: 12, title: 'Декември'}
  ],

  monthsShortOptions: [
    {id: 1, title: 'Янр.'},
    {id: 2, title: 'Фев.'},
    {id: 3, title: 'Мар.'},
    {id: 4, title: 'Апр.'},
    {id: 5, title: 'Май'},
    {id: 6, title: 'Юни'},
    {id: 7, title: 'Юли'},
    {id: 8, title: 'Авг.'},
    {id: 9, title: 'Сеп.'},
    {id: 10, title: 'Окт.'},
    {id: 11, title: 'Ное'},
    {id: 12, title: 'Дек.'}
  ],

  contragentType: {
    10: {title: 'Дентален Лекар'},
    20: {title: 'Зъботехник'},
    30: {title: 'Контрагент'},
    40: {title: 'Дентален Тръговец'},
    50: {title: 'Други'},
    60: {title: 'Фирма'}
  },
  contragentDegree: {
    1: {title: 'д-р'},
    2: {title: 'доц.'},
    3: {title: 'проф.'},
    4: {title: 'акад.'}
  },
  contragentSpeciality: {
    'Ендодонтия': 'Ендодонтия',
    'Пародонтология': 'Пародонтология',
    'Хирургия': 'Хирургия',
    'Протетична ДМ': 'Протетична ДМ',
    'Детска ДМ': 'Детска ДМ',
    'Имплантология': 'Имплантология',
    'Обща ДМ': 'Обща ДМ',
    'Ортодонтия': 'Ортодонтия',
    'Естетична ДМ': 'Естетична ДМ'
  },
  cityType: {
    1: {title: 'гр.'},
    2: {title: 'с.'}
  },

  paymentType: {
    1: {title: 'Приход'},
    2: {title: 'Разход'}
  },
  paymentDocument: {
    1: {title: 'Фактура'},
    2: {title: 'Без документ'},
    3: {title: 'Кредитно известие'}
  },
  paymentMethod: {
    1: {title: 'Банка', bg: 'По банков път', en: 'Bank Transfer'},
    2: {title: 'Каса', bg: 'На каса', en: 'In Cache'},
    3: {title: 'Наложен платеж', bg: 'С наложен платеж', en: 'Cache on Delivery'},
    4: {title: 'ПОС', bg: 'ПОС', en: 'POS'}
  },
  paymentStatus: {
    1: {title: 'Неплатено'},
    2: {title: 'Платено'}
  },
  subjectType: {
    1: {
      1010: {title: 'Абонамент'},
      1020: {title: 'Реклама'},
      1030: {title: 'Научна литература'},
      1040: {title: 'Такса научно събитие'},
      1050: {title: 'Реклама в дигиталното издание'},
      1060: {title: 'Спонсорство'},
      1070: {title: 'Други'},
      1080: {title: 'Вноска по договор'},

      1090: {title: 'Facebook реклама'},
      1100: {title: 'Международна реклама'},
      1110: {title: 'Покана "Усмивка на годината"'}
    },
    2: {
      2010: {title: 'Офис консумативи'},
      2020: {title: 'Куриери'},
      2030: {title: 'Телефония'},
      2040: {title: 'Заплати'},
      2050: {title: 'Осигуровки'},
      2060: {title: 'Печат издание'},
      2070: {title: 'Разпространение'},
      2080: {title: 'Хонорари'},
      2090: {title: 'Бонуси'},
      2100: {title: 'Данъци'},
      2110: {title: 'Други'},

      2120: {title: 'Наем'},
      2130: {title: 'ДДС'},
      2140: {title: 'Печат брошури'},
      2150: {title: 'Печат други'},
      2160: {title: 'Счетоводство'},
      2170: {title: 'Хонорар преводач'},
      2180: {title: 'Хонорар коректор'},
      2190: {title: 'Хонорар соц. медия'},
      2200: {title: 'Разходи соц. медия'},
      2210: {title: 'Усмивка на годината'}
    }
  },
  subjectDelivery: {
    1: 'БП Обикновена',
    2: 'БП Препоръчана',
    3: 'Куриер',
    4: 'Online'
  },
  subscriptionType: {
    1: {title: 'Стандартен', short: 'Стд.', discount: 0},
    2: {title: 'Промоционален', short: 'Промо', discount: 10},
    3: {title: 'ВИП', short: 'ВИП', discount: 100}
  },
  subscriptionVariant: {
    1: {title: 'Вариант 1', short: 'Вар. 1', price: 150, disabled: false},
    2: {title: 'Вариант 2', short: 'Вар. 2', price: 170, disabled: false},
    3: {title: 'Вариант 3', short: 'Вар. 3', price: 150, disabled: false},
    4: {title: 'Пакет Digital', short: 'Digital', price: 140, disabled: false},
    5: {title: 'Пакет Premium', short: 'Premium', price: 200, disabled: false}
  },

  permissions: {
    payments: 'Паричен поток',
    contragents: 'Контрагенти',
    literature: 'Литература',
    events: 'Събития',
    labels: 'Етикети',
    reports: 'Отчети'
  }

}
